import ImgCard from '@/components/molecules/ImgCard';
import CoupangGuideImgCard from '@/components/organisms/CoupangGuideImgCard';
import LotteonGuideImgCard from '@/components/organisms/LotteonGuideImgCard';
import { PallangGuideImgCard } from '@/components/organisms/PallangGuideImgCard';
import Street11GuideImgCard from '@/components/organisms/Street11GuideImgCard';
import { TossGuide } from '@/components/organisms/TossGuide';
import { ZigzagGuideImgCard } from '@/components/organisms/ZigzagGuideImgCard';

type MarketGuideImageCardProps = {
  guideImageUrl: string;
  marketName: string;
};

const MarketGuideImageCard = ({ guideImageUrl, marketName }: MarketGuideImageCardProps) => {
  switch (marketName) {
    case '쿠팡':
      return <CoupangGuideImgCard />;

    case '11번가':
      return <Street11GuideImgCard />;

    case '롯데온':
      return <LotteonGuideImgCard />;

    case '토스쇼핑':
      return <TossGuide />;

    case '팔랑':
      return <PallangGuideImgCard />;

    case '지그재그':
      return <ZigzagGuideImgCard />;

    default:
      return <ImgCard src={guideImageUrl} />;
  }
};

export default MarketGuideImageCard;
